module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Chat now":"Chat now！","Type a message":"Type a message","Current visitor status":"Visitor status, please ","login":"login","Send":"Send","Live room does not exist":"Live room does not exist"},"zh":{"Chat now":"快来互动吧！","Type a message":"说点什么","Current visitor status":"当前为游客身份，请先","login":"登录","Send":"发送","Live room does not exist":"直播间不存在"}}')
  delete Component.options._Ctor
}
